import { FlexContainer, Hr, Img } from "../../../design";
import Logo from "../../../assets/imgs/swirepay-logo.svg";
import React from "react";
import SmallScreenView from "../index";
import { useHistory } from "react-router-dom";

type Props = {
  children: Node,
  invoiceLinkId: String,
}

const SmallScreenHeader = (props: Props) => {
  const { 
    children, 
    paymentCheckout, 
    bankImageUrl, 
    largeLogo, 
    cancelUrlLink,
  } = props;

  const history = useHistory();

  return (
    <SmallScreenView>
      { cancelUrlLink && 
        (
          <FlexContainer
            justifyContent="flex-end"
            alignItems="center"
            width="100%"
            className="px-1"
            marginTop="5% !important"
            marginBottom="5% !important"
          >
            <button 
              onClick={() => { history.push(cancelUrlLink); }}
              className="px-4 py-2"
              style={{
                color: "#0b64bc",
                borderRadius: '10px',
                borderStyle: 'none',
                marginTop: '15px',
                backgroundColor: '#fff',
                width: '95px',
                height: '42px',
                fontWeight: 'bold',
                fontSize: '15px',
              }}
            >
              Cancel
            </button>
          </FlexContainer>
        )
      }
      {
        !paymentCheckout && (
          <FlexContainer 
            paddingTop="10px" 
            paddingBottom="20px" 
            justifyContent="center" 
            alignContent="center" 
          >
            <Img src={Logo} width="180" />
          </FlexContainer>
        )
      }

      {
        paymentCheckout && (
          <>
          <FlexContainer 
            paddingTop="10px" 
            paddingBottom="-10px"
          >
            <Img 
              width="180" 
              src={largeLogo || bankImageUrl} 
            />
          </FlexContainer>
          </>
        )
      }
      <div className="px-1 px-md-4 mt-2">
        {children}
      </div>
      <Hr marginTop="0px" />
    </SmallScreenView>
  )
};

export default SmallScreenHeader;
